'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBuild = function MdBuild(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.8 31.6c0.7 0.5 0.7 1.7-0.1 2.4l-3.9 3.8c-0.7 0.7-1.6 0.7-2.3 0l-15.2-15.1c-3.8 1.4-8.3 0.7-11.5-2.5-3.3-3.4-4.2-8.4-2.1-12.4l7.3 7.2 5-5-7.2-7.2c4-1.8 9-1.2 12.4 2.2 3.2 3.2 3.9 7.7 2.5 11.5z' })
        )
    );
};

exports.default = MdBuild;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/build.js
// module id = 1323
// module chunks = 168707334958949